import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { WireFrameExtractService, WireFrameExtractOptions, WireFrameExtractResult } from '../wire-frame-extract-service';
import { WireFrameExtractApi, type WireFrameExtractResponse } from '@/domains/specification/apis/wire-frame-extract-api';
import { SpecificationModel } from '@/domains/specification/models/specification-model';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class WireFrameExtractServiceImpl implements WireFrameExtractService {
    constructor(
        @inject(WireFrameExtractApi)
        private readonly _wireFrameExtractApi: WireFrameExtractApi,
        @inject(SpecificationModel)
        private readonly _specificationModel: SpecificationModel,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    async extract(options: WireFrameExtractOptions): Promise<WireFrameExtractResult> {
        const data = await this._wireFrameExtractApi.extractWireFrame({
            s3_key: options.s3Key,
            base64_image_data: options.base64ImageData,
            taskId: this._currentTaskService.taskId,
        });

        // 更新规格说明书模型中的剩余次数
        this._specificationModel.update(state => ({
            ...state,
            wireframeExtractConfig: {
                ...state.wireframeExtractConfig,
                remainingCount: data.remaining_count,
            },
        }));

        return this._convertResponse(data);
    }

    private _convertResponse(response: WireFrameExtractResponse): WireFrameExtractResult {
        return {
            figureId: response.original_figure_id,
            taskId: this._currentTaskService.taskId,
            wireframeUrl: response.wireframe_url,
            wireframeS3Key: response.wireframe_s3_key,
            remainingCount: response.remaining_count,
        };
    }
}
